import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "cross",
  "use": "cross-usage",
  "viewBox": "0 0 10 10",
  "content": "<symbol viewBox=\"0 0 10 10\" xmlns=\"http://www.w3.org/2000/svg\" id=\"cross\"><path d=\"M1 9L9 1\" stroke-width=\"1.5\" /><path d=\"M1 1L9 9\" stroke-width=\"1.5\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol